import '../assets/NcAppNavigationNew-BKfawNII.css';
import NcButton from "./NcButton.mjs";
import { n as normalizeComponent } from "../chunks/_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  components: {
    NcButton
  },
  props: {
    buttonId: {
      type: String,
      required: false,
      default: ""
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    text: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "primary",
      validator(value) {
        return ["primary", "secondary", "tertiary"].indexOf(value) !== -1;
      }
    }
  },
  emits: ["click"]
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "app-navigation-new" }, [_c("NcButton", { attrs: { "id": _vm.buttonId, "disabled": _vm.disabled, "type": _vm.type }, on: { "click": function($event) {
    return _vm.$emit("click");
  } }, scopedSlots: _vm._u([{ key: "icon", fn: function() {
    return [_vm._t("icon")];
  }, proxy: true }], null, true) }, [_vm._v(" " + _vm._s(_vm.text) + " ")])], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "810cb824"
);
const NcAppNavigationNew = __component__.exports;
export {
  NcAppNavigationNew as default
};
